import CustomerProfitability from "./CustomerProfitability";
export default CustomerProfitability;